import { InputError } from '@mantine/core';
import { defaultInputProps } from '../default-props';
export const inputErrorProps = InputError.extend({
    defaultProps: defaultInputProps,
});
